<div mat-dialog-content class="dialog-content">
  <p>{{ data.id ? 'Stationsinformation ändern' : 'Neue Stationsinformation hinzufügen' }}</p>

  <div class="form-row" style="flex-direction: column; align-items: flex-start;">
    <div style="display: flex; align-items: center; width: 100%;">
      <label class="form-label" style="margin-right: 8px;">Bezeichnung:</label>
      <mat-form-field appearance="fill" class="input-field" style="flex: 1;">
        <input matInput
               [(ngModel)]="data.infoLabel"
               required
               (ngModelChange)="checkName()" />
      </mat-form-field>
    </div>

    <div *ngIf="nameAlreadyExists" class="warning-text">
      {{ errorMessage }}
    </div>
  </div>

  <div class="form-row">
    <label class="form-label">Icon</label>
    <div class="input-field" style="display: flex; align-items: center;">
      <img *ngIf="iconPreview"
           [src]="iconPreview"
           width="50"
           height="50"
           alt="iconPreview"
           (error)="onImageError($event)"
           style="margin-right: 12px; border: 1px solid #ccc; border-radius: 4px;" />

      <input type="file"
             (change)="onFileSelected($event)"
             accept=".png"
             hidden
             #fileInput>

      <button mat-stroked-button (click)="fileInput.click()">
        <mat-icon>cloud_upload</mat-icon>
        {{ iconPreview && !selectedFile ? 'Ändern' : 'Importieren' }}
      </button>
    </div>
  </div>

  <div class="toggle-row" style="display: flex; align-items: center; justify-content: space-between; margin: 20px 0;">
    <label class="form-label" style="margin: 0; margin-right: 16px;">Status (aktiv/inaktiv)</label>
    <div style="display: flex; align-items: center;">
      <span style="margin-right: 8px; font-size: 14px; color: #666;">
        {{active ? 'Aktiv' : 'Inaktiv'}}
      </span>
      <mat-slide-toggle
        [(ngModel)]="active"
        name="active"
        [class.active-green]="active"
        [class.inactive-red]="!active"
        style="transform: scale(1.2);">
      </mat-slide-toggle>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="onCancel()">Abbrechen</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="!isFormValid">
      {{ data.id ? 'Speichern' : 'Hinzufügen' }}
    </button>
  </div>
</div>
